// removed by extract-text-webpack-plugin
module.exports = {"borrowers-message":"_2HtByca5Kroo_61tiXrZrr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Congrats/style.scss
// module id = 2583
// module chunks = 1